import {sides} from "../../const/sides";
import cloneDeep from "lodash/cloneDeep";

export function shareDataConverter(loadedData, options){
    let sidesList =  [sides.LEFT, sides.RIGHT];
    const sponsorImage = loadedData.imagesData.sponsorImages;
    const teamImage = loadedData.imagesData.teamImage;

    sidesList.forEach(imageSide => {
            // if old version & side === long or short
            if(loadedData?.version !== 1) {
                //if model has sleeve variation
                const longSleeve = `${imageSide}_long`;
                const updateSponsorImagesData = (newKey, oldKey) => {
                    sponsorImage[newKey].forEach(layer => {
                        if (layer) {
                            layer.id = `image_${newKey}_${Math.random() * 1000}`;
                            layer.layerMeta.position = options.positions.image[oldKey];
                        }
                    })
                }

                if (sponsorImage) {
                    sponsorImage[longSleeve] = cloneDeep(sponsorImage[imageSide]);
                    if (options?.sleeve) {
                        if (loadedData?.membersData?.members[0]?.data?.sleeve === "Short") {
                            //first member has short sleeve, left and right values must have loaded params, left_long & right_long must have default value
                            updateSponsorImagesData(longSleeve, longSleeve)
                        } else {
                            //left and right values must have default value, left_long & right_long must have loaded params
                            updateSponsorImagesData(imageSide, imageSide)
                        }
                    } else {
                        //if model without variation, left and long sides must have null, left_long and right_long sides must have left and right side values
                        updateSponsorImagesData(longSleeve, longSleeve);
                        sponsorImage[imageSide] = Array(sponsorImage[imageSide].length).fill(null);
                    }
                }

                if (teamImage) {

                    teamImage[longSleeve] = teamImage[imageSide];
                    teamImage.layersMeta[longSleeve] = cloneDeep(teamImage.layersMeta[imageSide])

                    if (options?.sleeve) {
                        if (loadedData?.membersData?.members[0]?.data?.sleeve === "Short") {
                            //first member has short sleeve, left and right values must have loaded params, left_long & right_long must have default value
                           if(teamImage.layersMeta[longSleeve]) teamImage.layersMeta[longSleeve].position = options.positions.image[longSleeve];
                        } else {
                            //left and right values must have default value, left_long & right_long must have loaded params
                            if(teamImage.layersMeta[longSleeve]) teamImage.layersMeta[longSleeve].position = teamImage.layersMeta[imageSide].position;
                            if(teamImage.layersMeta[imageSide]) teamImage.layersMeta[imageSide].position = options.positions.image[imageSide];
                        }
                    } else {
                        //if model without variation, left and long sides must have null, left_long and right_long sides must have left and right side values
                        if(teamImage.layersMeta[longSleeve]) teamImage.layersMeta[longSleeve].position = teamImage.layersMeta[imageSide].position;
                        teamImage[imageSide] = false;
                        teamImage.layersMeta[imageSide] = null;
                    }
                }
            }
    })
    return loadedData;
}